enum AuthResponseEnum {
  Code = 'code'
}

enum AuthGrantTypeEnum {
  AuthorizationCode = 'authorization_code',
  Password = 'password',
  RefreshToken = 'refresh_token'
}

enum AuthErrorResponsesEnum {
  InvalidGrant = 'invalid_grant'
}

enum StorageKeyOptionsEnum {
  AccessData = 'access_data',
  OrganizationsData = 'organizations_data',
  FarmsData = 'farms_data'
}

export {
  AuthErrorResponsesEnum,
  AuthGrantTypeEnum,
  AuthResponseEnum,
  StorageKeyOptionsEnum
};
